import { Trans, useTranslation } from 'react-i18next';
import { DateFormat, formatLocalDateWithFallback } from '@/common/utils/dateFormats';

const formatDate = (dateString: string | null | undefined) =>
  formatLocalDateWithFallback({
    dateString,
    formatStr: DateFormat.MONTH_SHORT_DAY_SHORT_YEAR,
    fallback: '',
  });

export const DeadlineRiskMessage = ({
  forecastedFinish,
  deadline,
  sourceItemName,
}: {
  forecastedFinish: string | null | undefined;
  deadline: string | null | undefined;
  sourceItemName: string | null | undefined;
}) => {
  const { t } = useTranslation();

  if (!forecastedFinish || !deadline) {
    return <span>{t(($) => $.loopVisualization.timelineTooltip.atRiskDeadlineExceeded)}</span>;
  }

  if (sourceItemName) {
    return (
      <span>
        <Trans
          i18nKey="loopVisualization.timelineTooltip.atRiskAncestorDeadline"
          t={t}
          values={{
            forecastedFinish: formatDate(forecastedFinish),
            deadline: formatDate(deadline),
            sourceItemName,
          }}
          components={{ bold: <strong /> }}
        />
      </span>
    );
  }

  return (
    <span>
      <Trans
        i18nKey="loopVisualization.timelineTooltip.atRiskOwnDeadline"
        t={t}
        values={{ forecastedFinish: formatDate(forecastedFinish), deadline: formatDate(deadline) }}
        components={{ bold: <strong /> }}
      />
    </span>
  );
};
